import axios from '@/utils/api'

const state = {
}

const getters = {
}

const actions = {

  async getFilaByIdProcesso ({ commit }, id) {
    const data = await axios({
      method: 'get',
      url: `filaPlantaMemorial/${id}`
    })
    return data
  },

  async regerar ({ commit }, idsProcessos) {
    const data = await axios({
      method: 'post',
      data: idsProcessos,
      url: 'filaPlantaMemorial/regerarAnaliseAutomatizada'
    })
    return data
  },

  async deletarFilaByIdProcesso ({commit}, id) {
    await axios({
      method: 'delete',
      url: `filaPlantaMemorial/${id}`
    })
  }
}

const mutations = {
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/fila/filaPlantaMemorial.js